export default "__VITE_ASSET__UY3mkiAz__"